import moment from 'moment';
import SubscriptionStateApi from '@/api/SubscriptionStateApi';

async function isDormantWinback() {
  const MONTHS_UNTIL_WINBACK_EXPERIENCE = 3;
  const { isDormant, since } = await SubscriptionStateApi.simplifiedSubscriptionState();
  return isDormant && since < moment().subtract(MONTHS_UNTIL_WINBACK_EXPERIENCE, 'month').format();
}

export default isDormantWinback;
